import { render, staticRenderFns } from "./SmdRecentActivityFeed.vue?vue&type=template&id=3609dd71&"
import script from "./SmdRecentActivityFeed.vue?vue&type=script&lang=js&"
export * from "./SmdRecentActivityFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports